require('./latestCardHistory.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ core
const { formatText } = require('core/i18n').i18n;
// @ utilities
const DateHelper = require('utilities/dateHelper');
// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const  { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
// @ constants
const {
    DATETIME_FORMAT_WITH_SLASHES,
    DATE_FORMAT_WITH_SLASHES
} = require('constants/index');

const {
    CARD_HISTORY_FIELD_HIRE_DATE,
    CARD_HISTORY_FIELD_ACTIVATION_DATE,
    CARD_HISTORY_FIELD_DELIVERY_DATE,
    CARD_HISTORY_FIELD_STAMP_PENDING_DATE,
    CARD_HISTORY_FIELD_PREVIOUS_CARD_LIMIT,
    CARD_HISTORY_FIELD_LAST_EDIT_DATE,
    CARD_HISTORY_FIELD_PIN_EDIT_DATE_ATM,
    CARD_HISTORY_FIELD_PIN_EDIT_DATE_WEB_APP,
    CARD_HISTORY_FIELD_PIN_RESET_DATE,
    CARD_HISTORY_FIELD_BLOCKING_DATE,
    CARD_HISTORY_FIELD_WITHDRAWAL_DATE,
} = require('constants/contactCenter/latestCardHistory');

class LatestCardHistory extends React.Component {
    constructor(props){
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    datesByCardType(immCard) {
        return (item) => {
            const key = item.key;
            if (immCard.get('isOpenYoung')) {
                return !(key === CARD_HISTORY_FIELD_PREVIOUS_CARD_LIMIT || key === CARD_HISTORY_FIELD_LAST_EDIT_DATE
                  || key === CARD_HISTORY_FIELD_PIN_EDIT_DATE_ATM || key === CARD_HISTORY_FIELD_PIN_EDIT_DATE_WEB_APP
                  || key === CARD_HISTORY_FIELD_ACTIVATION_DATE);

            } else if (immCard.get('type') === 'ecard') {
                return !(key === CARD_HISTORY_FIELD_PREVIOUS_CARD_LIMIT || key === CARD_HISTORY_FIELD_LAST_EDIT_DATE
                  || key === CARD_HISTORY_FIELD_PIN_EDIT_DATE_ATM || key === CARD_HISTORY_FIELD_PIN_EDIT_DATE_WEB_APP
                  || key === CARD_HISTORY_FIELD_ACTIVATION_DATE || key === CARD_HISTORY_FIELD_PIN_RESET_DATE);

            } else if (immCard.get('isViaT')) {
                return !(key === CARD_HISTORY_FIELD_ACTIVATION_DATE || key === CARD_HISTORY_FIELD_PIN_RESET_DATE);
            }
            return true;
        }
    }

    buildItems(immData) {

        const { immCard } = this.props;
        const arrangedItems = [
            { key: CARD_HISTORY_FIELD_HIRE_DATE, type: 'date' },
            { key: CARD_HISTORY_FIELD_ACTIVATION_DATE, type: 'datetime' },
            { key: CARD_HISTORY_FIELD_DELIVERY_DATE, type: 'datetime' },
            { key: CARD_HISTORY_FIELD_STAMP_PENDING_DATE, type: 'datetime' },
            { key: CARD_HISTORY_FIELD_PREVIOUS_CARD_LIMIT, type: 'text' },
            { key: CARD_HISTORY_FIELD_LAST_EDIT_DATE, type: 'datetime' },
            { key: CARD_HISTORY_FIELD_PIN_EDIT_DATE_ATM, type: 'datetime' },
            { key: CARD_HISTORY_FIELD_PIN_EDIT_DATE_WEB_APP, type: 'datetime' },
            { key: CARD_HISTORY_FIELD_PIN_RESET_DATE, type: 'datetime' },
            { key: CARD_HISTORY_FIELD_BLOCKING_DATE, type: 'datetime' },
            { key: CARD_HISTORY_FIELD_WITHDRAWAL_DATE, type: 'datetime' },
        ];

        const items = immData.toJS();
        const datesByCardType = this.datesByCardType(immCard);
        const notAvailableText = formatText('latestCardHistory-notAvailable');

        return arrangedItems.filter(datesByCardType).map( (def, index) => {
            const key = def.key;
            const item = items[key];
            let value = notAvailableText;
            if ( items[key] ) {
                switch (def.type) {
                    case 'datetime':
                        value = DateHelper.formatDate(item.value, DATETIME_FORMAT_WITH_SLASHES);
                        break;
                    case 'date':
                        value = DateHelper.formatDate(item.value, DATE_FORMAT_WITH_SLASHES);
                        break;
                    default:
                        value = item.value;
                }
            }
            return (
                <OKInformativeListItem key={index} title={`latestCardHistory-${key}`}>
                    <div className="latest-card-history__value">
                        {value}
                    </div>
                </OKInformativeListItem>
            );
        });
    }

    render() {
        const { immLatestCardHistory } = this.props;
        const headerTitle = formatText('latestCardHistory-title');

        let content;
        if (immLatestCardHistory.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immLatestCardHistory.get('hasBeenFetch')) {
            const itemsContent = this.buildItems(immLatestCardHistory.get('data'));
            content = (
                <OKInformativeList columns={2}>
                    {itemsContent}
                </OKInformativeList>
            );
        } else {
            content = (
                <EmptyState
                    primaryText={formatText('commons-lostConnection')}
                />
            );
        }

        return (
            <div className="latest-card-history">
                <header className="latest-card-history__title">
                    <OKBoxTitle value={headerTitle} />
                </header>
                {content}
            </div>
        );
    }
}

LatestCardHistory.propTypes = {
    immLatestCardHistory: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
};

module.exports = LatestCardHistory;
